import { Formik } from 'formik';
import type { ReactNode } from 'react';
import type { WarrantyInput } from '@econtractor/types';
import { emptyWarranty } from './model';

interface WarrantyFormikProps {
    initial: WarrantyInput | null;
    save: (values: WarrantyInput) => Promise<number | false>;
    children: ReactNode;
}

const WarrantyFormik = ({ initial, save, children }: WarrantyFormikProps) => (
    <Formik
        initialValues={
            initial
                ? {
                      productId: initial.productId,
                      serialNumber: initial.serialNumber,
                      purchasedAt: initial.purchasedAt,
                      warrantyUntil: initial.warrantyUntil,
                      objectId: initial.objectId,
                  }
                : emptyWarranty
        }
        enableReinitialize
        onSubmit={async (values) => {
            await save(values);
        }}
    >
        {children}
    </Formik>
);

export default WarrantyFormik;
